import React, { useState, useEffect } from 'react';
//import { toast } from 'react-toastify'

import { Autocomplete, TextField } from '@mui/material';
import { useVendors_Uploadpage } from './hooks';
import { sortDropdownOptions } from '../utils';

function FilterVendorName({
    setVendorName,
	VendorName,
	setVendorNameId,
	VendorNameId,
    required
}) {

    //console.log(required);
    const [lable,setLable] = useState('Vendor Name')
    const [selected, setselected] = useState(null)

    useEffect(() => {
    if (!VendorName) {
        setselected(null);
    } else {
        setselected({
        vendorName: VendorName,
        _id: VendorNameId,
        });
    }
    }, [VendorName, VendorNameId]);
    
    useEffect(() => {
        if(required === 'true')
        {
            setLable('Vendor Name*')
        }
      }, [required]);


    const [options, setoptions] = useState([]);
	const vendor_list_hook = useVendors_Uploadpage();
	const [Focus, setFocus] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [open, setOpen] = useState(false);
	const [firstTime, setfirstTime] = useState(true);

    //const [lable,setLable] = useState(required)

	useEffect(() => {
		if (vendor_list_hook.hook.data) {
			setfirstTime(false);
			setoptions(sortDropdownOptions(vendor_list_hook.hook.data.data, (o) => o.vendorName))
		}
	}, [vendor_list_hook.hook.data, vendor_list_hook.hook.isSuccess]);

	useEffect(() => {
		vendor_list_hook.setArgs((args) => {
			return {
				...args,
				search: inputValue,
			};
		});
	}, [inputValue]);

    function changeProjectType(val) {
        setselected(val)
		//console.log(val);
		setVendorName(val?.vendorName);
        setVendorNameId(val?._id);
		// let obj = vendor_list_hook.hook.data.data.find((o) => (o.vendorId === val || o.vendorName === val));

		// if (obj) {
		// 	setVendorNameId(val._id);
		// }
        // else{
		// 	setVendorNameId(null)
		// 	setVendorName(null)
		// }
	}

	let stop = false;

    return (
        <>
            <div>
                <div className="flex gap-3">
                    <div className="grow">
                        <div className="lightT">
                            {firstTime && vendor_list_hook.hook.isPending ? (
                                <p className="px-4 py-2 border border-1 border-slate-300 rounded-md">
                                    Vendor Name{' '}
                                    <span className="text-sm text-slate-400 ps-4 inline-block">
                                        Loading...
                                    </span>
                                </p>
                            ) : (       
                                <Autocomplete
									id="vendor"
									filterOptions={(x) => x}
									options={options}
									getOptionLabel={(option) => option?.vendorName }
									isOptionEqualToValue={(option, value) =>
										option?._id === value?._id
									}
									value={selected}
									open={open}
									onOpen={() => {
										setOpen(true);
									}}
									onClose={() => {
										setOpen(false);
									}}
									onChange={(event, newValue) => changeProjectType(newValue)}
									onInputChange={(event, newInputValue) => {
										setInputValue(newInputValue);
									}}
									renderInput={(params) => (
										<TextField {...params} label={lable} />
									)}
									renderOption={(props, option) => {
										if (stop) return;
										if (vendor_list_hook.hook.isPending) {
											stop = true;
											return (
												<p key={'loading_vendor'} className="ml-2">
													Loading...
												</p>
											);
										}

										return (
											<li {...props} key={option?._id} >
												{option?.vendorName}
											</li>
										);
									}}
                                    onFocus={() => setFocus(true)}
                                    onBlur={() => setFocus(false)}
								/>
                            )}
                            {VendorName == null && Focus && required === 'true' && (
								<small className="text-red-600 ">
									Vendor name is required
								</small>
							)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FilterVendorName;
